import React from 'react'
import { useTimeoutWhen } from 'rooks'
import { ButtonIcon, Icon2 } from '@elamajs/ui-kit'
import theme from '../theme'
import * as Styled from './Toast.styled'
import { ToastData } from './Toast.types'

type Props = ToastData & { onRemove: () => void; className?: string; onClose?: () => void }

// eslint-disable-next-line @typescript-eslint/no-empty-function
const Toast: React.FC<Props> = ({ className, onRemove, onClose = () => {}, ...toast }) => {
  useTimeoutWhen(onClose, toast.duration, toast.isOpen && !!toast.duration)
  useTimeoutWhen(onRemove, 300, !toast.isOpen)

  return (
    <Styled.Container className={className}>
      <Styled.Header>
        <Styled.Icon as={Icon2} icon={toast.icon} color={theme.palette.black(20)} />
        <Styled.Title>{toast.title}</Styled.Title>
        {!!toast.duration && onClose && (
          <Styled.CloseButton
            as={ButtonIcon}
            type="button"
            icon="close"
            iconColor={theme.palette.black(20)}
            variant="transparent"
            onClick={onClose}
          />
        )}
      </Styled.Header>
      {toast.body && (
        <Styled.Body>
          <Styled.Description>{toast.body}</Styled.Description>
        </Styled.Body>
      )}
    </Styled.Container>
  )
}
export default Toast
